const initialState = {
  isFetching: null,
  isError: false,
  result: { content: [],status:true},
};

export const SELECT_NAME_OR_EMAIL_FETCHING = 'SELECT_NAME_OR_EMAIL_FETCHING';
export const SELECT_NAME_OR_EMAIL_FAILED = 'SELECT_NAME_OR_EMAIL_FAILED';
export const SELECT_NAME_OR_EMAIL_SUCCESS = 'SELECT_NAME_OR_EMAIL_SUCCESS';
export const SelectNameOrEmailReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case SELECT_NAME_OR_EMAIL_FETCHING:
      return { ...state, isFetching: true, isError: false };
    case SELECT_NAME_OR_EMAIL_FAILED:
      return {
        ...state,
        isFetching: false,
        isError: true,
        result: { content: [] },
      };
    case SELECT_NAME_OR_EMAIL_SUCCESS:
      return { ...state, isFetching: false, isError: false, result: payload };
    default:
      return state;
  }
};
